import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { UiHelper } from '../common/helpers/UiHelper';
import { AppHelper } from './AppHelper';
import { AppTheme } from '../styles/AppTheme';
import { Helper } from '../common/helpers/Helper';
// WIFI Icons
import SignalWifi4BarOutlinedIcon from '@material-ui/icons/SignalWifi4BarOutlined';
import SignalWifi3BarOutlinedIcon from '@material-ui/icons/SignalWifi3BarOutlined';
import SignalWifi2BarOutlinedIcon from '@material-ui/icons/SignalWifi2BarOutlined';
import SignalWifi1BarOutlinedIcon from '@material-ui/icons/SignalWifi1BarOutlined';
import SignalWifi0BarOutlinedIcon from '@material-ui/icons/SignalWifi0BarOutlined';
// Cellular Icons
import SignalCellular4BarOutlinedIcon from '@material-ui/icons/SignalCellular4BarOutlined';
import SignalCellular3BarOutlinedIcon from '@material-ui/icons/SignalCellular3BarOutlined';
import SignalCellular2BarOutlinedIcon from '@material-ui/icons/SignalCellular2BarOutlined';
import SignalCellular1BarOutlinedIcon from '@material-ui/icons/SignalCellular1BarOutlined';
import SignalCellular0BarOutlinedIcon from '@material-ui/icons/SignalCellular0BarOutlined';

import { Tooltip } from '@material-ui/core';

export class AppUiHelper extends UiHelper {

  static noImage = require('../assets/images/no-image.png');

  static itemStatusContainer(current) {
    const newState  = (current.state && current.state.toLowerCase() === 'live') ? 'ENABLED' : current.state
    return (
      <div className={css(Styles.statusOuterContainer)}>
        <div className={css(Styles.statusTag)} style={{ backgroundColor: AppHelper.getStatusBackgroundColorByKey(newState) }}>
          <span className={css(Styles.circleFill)} style={{ backgroundColor: AppHelper.getStatusColorByKey(newState) }}></span>
          <span className={css(Styles.statusText)}>{newState || ''}</span>
        </div>
        <div>
          {current.likeCount !== undefined &&
            <div className={css(Styles.countContainer)}>
              <div className={css(Styles.imageContainer)}>
                <i className='material-icons-outlined' style={{ fontSize: 20, color: AppTheme.primaryColor }}>thumb_up</i>
              </div>
              <p className={css(Styles.statusValue)}>{current.likeCount || 0}</p>
            </div>
          }
          {current.buyCount !== undefined &&
            <div className={css(Styles.countContainer, Styles.countSecondContainer)}>
              <div className={css(Styles.imageContainer)}>
                <i className='material-icons-outlined' style={{ fontSize: 20, color: AppTheme.primaryColor }}>shopping_basket</i>

              </div>
              <p className={css(Styles.statusValue)}>{current.buyCount || 0}</p>
            </div>
          }
        </div>
      </div>
    )
  }

  static placementContainer(current) {
    return (
      <div className={css(Styles.statusOuterContainer)}>
        <div className={css(Styles.statusTag)} style={{ backgroundColor: 'rgba(63, 208, 15, 0.1)' }}>
          <span className={css(Styles.statusText)}>{current.placementLabel}</span>
        </div>
      </div>
    )
  }

  static chipOrange(label, showDot = true) {
    if(!label) return
    return (<div className={css(Styles.statusTag)} style={{ backgroundColor: AppHelper.getStatusBackgroundColorByKey('away') }}>
      {showDot && <span className={css(Styles.circleFill)} style={{ backgroundColor: AppHelper.getStatusColorByKey('away') }}></span>}
      <span className={css(Styles.statusText)}>{label || ''.toLowerCase()}</span>
    </div>)
  }

  static chipPurple(label, showDot = true) {
    if (!label) return
    return (<div className={css(Styles.statusTag)} style={{ backgroundColor: AppHelper.getStatusBackgroundColorByKey('draft') }}>
      {showDot && <span className={css(Styles.circleFill)} style={{ backgroundColor: AppHelper.getStatusColorByKey('draft') }}></span>}
      <span className={css(Styles.statusText)}>{label || ''.toLowerCase()}</span>
    </div>)
  }
  static chipLive(label, showDot = false) {
    if(!label) return
    const newState  = (label && label.toLowerCase() === 'live') ? 'ENABLED' : label
    return (<div className={css(Styles.statusTag)} style={{ backgroundColor: AppHelper.getStatusBackgroundColorByKey('live') }}>
      {(label.toLowerCase() === 'live' || showDot) && <span className={css(Styles.circleFill)} style={{ backgroundColor: AppHelper.getStatusColorByKey('live') }}></span>}
      <span className={css(Styles.statusText)}>{newState || ''.toLowerCase()}</span>
    </div>)
  }

  static chipGreen(label, showDot = true) {
    if(!label) return
    return (<div className={css(Styles.statusTag)} style={{ backgroundColor: AppHelper.getStatusBackgroundColorByKey('live') }}>
      {showDot && <span className={css(Styles.circleFill)} style={{ backgroundColor: AppHelper.getStatusColorByKey('live') }}></span>}
      <span className={css(Styles.statusText)}>{label || ''}</span>
    </div>)
  }

  static chipDisabled(label, showDot = true) {
    if(!label) return
    return (<div className={css(Styles.statusTag)} style={{ backgroundColor: AppHelper.getStatusBackgroundColorByKey('disabled') }}>
      {showDot && <span className={css(Styles.circleFill)} style={{ backgroundColor: AppHelper.getStatusColorByKey('disabled') }}></span>}
      <span className={css(Styles.statusText)}>{label || ''.toLowerCase()}</span>
    </div>)
  }

  static chipError(label) {
    if(!label) return
    return (<div className={css(Styles.statusTag)} style={{ backgroundColor: AppHelper.getStatusBackgroundColorByKey('offline') }}>
      <span className={css(Styles.circleFill)} style={{ backgroundColor: AppHelper.getStatusColorByKey('offline') }}></span>
      <span className={css(Styles.statusText)}>{label || ''.toLowerCase()}</span>
    </div>)
  }

  static chipInSync(label) {
    return (<div className={css(Styles.statusTag, Styles.inSyncBg)}>
      <span className={css(Styles.statusIconsHolds)}><img className={css(Styles.statusIcons)} src={require('../assets/icons/in-sync.svg')}/></span>
      <span className={css(Styles.statusText)}>{label}</span>
    </div>)
  }

  static chipOutOfSync(label) {
    return (<div className={css(Styles.statusTag, Styles.outOfSyncBg)}>
      <span className={css(Styles.statusIconsHolds)}><img className={css(Styles.statusIcons)} src={require('../assets/icons/out-of-sync.svg')}/></span>
      <span className={css(Styles.statusText)}>{label}</span>
    </div>)
  }

  static getVideoThumbnail = (link) => {
    const Url = require('url-parse')
    const pUrl = new Url(link)
    const splittedUrl = pUrl.pathname.split('_')
    if (splittedUrl.length === 2) {
      const timestamp = parseInt(splittedUrl[1]);
      // Check if the timestamp is a valid date
      const date = new Date(timestamp);
      if (!isNaN(date.getTime())) {
        // Replace .mp4 with -tn.jpg
        pUrl.pathname = pUrl.pathname.replace('.mp4', '_tn.jpg');
        // console.log('pUrl.toString()', pUrl.toString())
        return pUrl.toString();
      } else {
        throw new Error('Invalid timestamp.');
      }
    } else {
      throw new Error('Invalid file format or missing timestamp.');
    }
  }

  static itemImage(current) {
    const image = current.imageLink || current.image
    let containerStyles = [Styles.spanImgContainer]
    if(current._LARGEIMAGE) containerStyles =  [Styles.spanImgContainerLarge]
    if(current._BORDER) containerStyles.push(Styles.containerBorder)
    return (
      <div className={css(Styles.spanContainer)}>
        <div className={css(containerStyles)}>
          {image ?
            <img src={current.image}
              onError={(e) => {
                e.target.src = AppUiHelper.noImage
              }}
              className={css(current._IMAGEFIT ? Styles.imageContentFit : Styles.imageContent)} />
            :
            <i className='material-icons-outlined' style={{ fontSize: 40, color: 'lightgray' }}>image</i>
          }
        </div>
      </div>
    )
  }

  static renderVideoThumbnailCustomStyle = (current, props = {}, uiHelperProps = {}) => {
    if (uiHelperProps && Object.keys(uiHelperProps).length > 0) {
      try {
        const videoThumbnail = AppUiHelper.getVideoThumbnail(current.content)
        return AppUiHelper.itemImage({ ...uiHelperProps, image: videoThumbnail })
      } catch (e) {
        return (
          <i className={'material-icons-outlined ' + css(Styles.icons)}>smart_display</i>
        )
      }
    } else {
      try {
        const videoThumbnail = AppUiHelper.getVideoThumbnail(current.content)
        return (
          <img alt={Helper.getString('assetImageAlt')} src={videoThumbnail}
            onError={(e) => {
              e.target.src = AppUiHelper.noImage
            }}
            className={css(props.imageStyle ? props.imageStyle : Styles.assetsImageContent)} />
        )
      } catch (e) {
        return (
          <i alt={Helper.getString('assetImageAlt')} className={'icons material-icons-outlined ' + css(props.iconStyle ? props.iconStyle : Styles.mediaDndIcons)} >smart_display</i>
        )
      }
    }
  }

  static getChipsFromArray = (dataArray) => {
    return (
      <div className={css(Styles.tagChipContainer)}>
        {dataArray && dataArray.length > 0 &&
          dataArray.map((x, i) => AppUiHelper.chipLive(x))
        }
      </div>
    )
  }

  static calculateRenderDimensions = (current, maxWidth, maxHeight) => {
    if (!current || !current.width || !current.height || !maxWidth || !maxHeight) {
      throw new Error('Invalid input: current must have width and height properties')
    }
    if (current.width > current.height) {
      return {
        width: current.width / (current.width / maxWidth),
        height: current.height / (current.height / maxHeight),
      }
    } else if (current.width < current.height) {
      return {
        width: current.width / (current.height / maxHeight),
        height: current.height / (current.height / maxHeight),
      }
    } else {
      throw new Error('Invalid orientation: must be PORTRAIT or LANDSCAPE')
    }
  }

  static getReportsStatsImages = () => {
    return (
      {
        campaigns: require('../assets/icons/partner-reports/campaign.svg'),
        creatives: require('../assets/icons/partner-reports/creative.svg'),
        impressions: require('../assets/icons/partner-reports/impression.svg'),
        spots: require('../assets/icons/partner-reports/spots.svg'),
        venues: require('../assets/icons/partner-reports/venue.svg'),
        screens: require('../assets/icons/partner-reports/venue.svg'),
        revenue: require('../assets/icons/partner-reports/revenue.svg')
      }
    )
  }

  static getDaStatsInfo = () => {
    return (
      {
        totalVenues: {
          title: 'Online Screens',
          image: require('../assets/icons/partner-reports/venue.svg'),
          order: '1'
        },
        totalGet: {
          title: 'Exchange Get Ads',
          image: require('../assets/icons/partner-reports/campaign.svg'),
          order: '2'
        },
        totalAds: {
          title: 'Leased Ads',
          image: require('../assets/icons/partner-reports/impression.svg'),
          order: '3'
        },
        totalPop: {
          title: 'PoPs',
          image: require('../assets/icons/partner-reports/pop.svg'),
          order: '4'
        },
        totalErr: {
          title: 'Errors',
          image: require('../assets/icons/partner-reports/error-ad.svg'),
          order: '5'
        },
        totalCmsPop: {
          title: 'CMS PoPs',
          image: require('../assets/icons/partner-reports/pop-cms.svg'),
          order: '6'
        },
        totalAdApiReqs: {
          title: 'Dolphin Ad API Calls',
          image: require('../assets/icons/partner-reports/campaign.svg'),
          order: '7'
        },
      }
    )
  }

  static getIconChip({ icon, chipColor, tooltipText }) {
    if (!icon) return null
    const chipContent = (
      <div className={css(Styles.signalIconStatus)} style={{ backgroundColor: AppHelper.getStatusBackgroundColorByKey(chipColor) }}>
        {icon}
      </div>
    )
    return tooltipText ? <Tooltip title={tooltipText}>{chipContent}</Tooltip> : chipContent
  }

  static getVenueSignalStatus(venue) {
    if (!venue || !venue.latestDeviceFeed) return null
    const { networkType, wifiSignalStrength, wifiSpeed, cellularSignalStrength, networkConnectionStatus = true  } = venue.latestDeviceFeed
    // MUI4 Icon Style
    const iconStyle = { fontSize: '20px', color: '#4a4a4a' }
    // Define signal strength mappings for Wi-Fi and Cellular
    const wifiIcons = [SignalWifi0BarOutlinedIcon, SignalWifi1BarOutlinedIcon, SignalWifi2BarOutlinedIcon, SignalWifi3BarOutlinedIcon, SignalWifi4BarOutlinedIcon]
    const cellularIcons = [SignalCellular0BarOutlinedIcon, SignalCellular1BarOutlinedIcon, SignalCellular2BarOutlinedIcon, SignalCellular3BarOutlinedIcon, SignalCellular4BarOutlinedIcon]
    const statusColors = ['offline', 'offline', 'offline', 'away', 'live']
    // WiFi
    if (networkType === 'Wi-Fi' && wifiSignalStrength >= 0 && wifiSignalStrength <= 4) {
      const WifiIcon = wifiIcons[wifiSignalStrength]
      const icon = <WifiIcon style={iconStyle} />
      const chipColor = statusColors[wifiSignalStrength]
      const tooltipText = wifiSpeed ? `${wifiSpeed} Mbps` : null

      return this.getIconChip({ icon, chipColor, tooltipText })
    }
    // Cellular
    if (networkType === 'Cellular' && cellularSignalStrength >= 0 && cellularSignalStrength <= 4) {
      const CellularIcon = cellularIcons[cellularSignalStrength]
      const icon = <CellularIcon style={iconStyle} />
      const chipColor = statusColors[cellularSignalStrength]

      return this.getIconChip({ icon, chipColor })
    }

    // Ethernet
    if (networkType === 'Ethernet') {
      const icon = <span className='material-icons-outlined' style={iconStyle}>lan</span>
      const chipColor = networkConnectionStatus ? 'live' : 'offline'
      return this.getIconChip({ icon, chipColor })
    }
    // Default return if no signal type matches
    return null
  }

}


const Styles = StyleSheet.create({
  outOfSyncBg:{
    backgroundColor: 'rgba(87, 87, 87, 0.1)'
  },
  inSyncBg:{
    backgroundColor: 'rgba(32, 41, 241, 0.1)'
  },
  statusIconsHolds:{
    display: 'flex',
    marginRight: 2
  },
  statusIcons:{
    width:12,
    height:12
  },
  tagChipContainer:{
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    gap: '5px',
    maxWidth: '300px'
  },
  assetsImageContent: {
    borderRadius: 8,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  mediaDndIcons:{
    color: '#ffffff',
    padding: '0px 12px',
    fontSize: 55,
    marginTop: 28
  },
  statusValue: {
    fontSize: 16,
    color: '#7D7D7D',
    margin: 0,
    marginLeft: 8
  },
  imageContainer: {
    width: 20,
    height: 20
  },
  countContainer: {
    display: 'flex'
  },
  countSecondContainer: {
    marginTop: 8
  },
  statusOuterContainer: {
    display: 'flex'
  },
  statusTag:{
    display: 'flex',
    alignItems: 'center',
    padding: '7px 16px',
    justifyContent: 'center',
    borderRadius: '6px',
    maxWidth:'max-content'
  },
  circleFill:{
    width: 10,
    height: 10,
    borderRadius: '50%',
    marginRight:4,
    minWidth: 10
  },
  statusText:{
    color: 'rgba(87, 87, 87, 1)',
    fontSize: 14,
    paddingLeft: 2
  },
  icons:{
    fontSize: 30,
    color: '#fff',
    marginRight: 12,
    background: 'rgb(228, 228, 228)',
    borderRadius: 8,
    width: 40,
    height: 40,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  spanContainer: {
    display: 'flex'
  },
  spanImgContainer: {
    width: 40,
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12
  },
  spanImgContainerLarge: {
    width: 75,
    height: 75,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12
  },
  containerBorder: {
    border: '1px solid #d3d3d3',
    borderRadius: 6,
    overflow: 'hidden'
  },
  imageContentFit: {
    height: '100%',
    width: '100%',
    borderRadius: 6,
    objectFit: 'contain'
  },
  imageContent: {
    height: '100%',
    width: '100%',
    borderRadius: 6,
    objectFit: 'cover',
    border: 'solid 1px whitesmoke'
  },
  signalIconStatus:{
    display: 'flex',
    alignItems: 'center',
    padding: '7px 8px',
    justifyContent: 'center',
    borderRadius: '6px',
    maxWidth:'max-content'
  }
})



// WEBPACK FOOTER //
// ./src/helpers/AppUiHelper.js